import React from "react";
import "./Other.scss";
import "./Pricing.scss"
// import Footer from "../common/Footer/Foot";
import Footer from "../common/Footer/NewFooter";
import Header from "../common/Header/Header";
import platform from "../../assets/images/mains/pricing.svg";
import { NavLink } from "react-router-dom";
import tick from "../../assets/images/mains/tick.svg";
// import tick2 from "../../assets/images/mains/tickInCircle.svg";
import StartTrialBtn from "../Home/StartTrialBtn";
const ShopifyPricingPlans = () => {
  return (
    <div id='pricing'>
      <Header />
      <PricingPlans />
      <Pricing />
      <Footer />
    </div>
  );
};

export default ShopifyPricingPlans;

export const PricingPlans = () => {
  return (
    <div className="hero-container custom-hero-container container-sm mb-5">
      <div className=" hero-row custom-hero-row row m-0 w-100 h-100">
        <div className="col-12 col-sm-6 heroText-container flex">
          <div className="heroTitle w-100 mt-5">
            <h2>Pricing</h2>
          </div>
          <div className="heroDesc w-100 my-4">
            <p>
              We provide flexible pricing plans.
              <NavLink className="mx-2" to="/contact-us">
                Contact us
              </NavLink>
              if you have any questions.
            </p>
          </div>
        </div>
        <div className="col-12 col-sm-6 mt-5 mt-sm-0">
          <div className="hero-img-container">
            <img className="img-fluid pricing-hero-img" src={platform} alt="platform" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const Pricing = () => {
  return (
    <div className="pricing-container container-sm">
      <div className="row pt-5 pb-5 mt-5 mb-5 ">
        <div className="col-sm-12 col-md-6 col-xl-3 p-3 d-flex">
          <div className="shadow bg-white rounded p-3 w-100">
            <p className="sub-heading text-uppercase">
              <b>FREE</b>
            </p>
            <h3>Free</h3>
            <div className="features">
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Cookie-less analytics
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Marketing performance with UTM parameters
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                1 dashboard user
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Up to 1,000 monthly unique visitors
              </p>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-xl-3 p-3 d-flex">
          <div className="shadow bg-white rounded p-3 w-100">
            <p className="sub-heading">GROWTH</p>
            <h3>﹩249/month</h3>
            <div className="features">
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Cookie-less analytics
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Marketing performance with UTM parameters
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                3 dashboard user
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Up to 5,000 monthly unique visitors
              </p>
              
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Persona prediction with offers
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                SEO
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Speed
              </p>
            </div>
          </div>
        </div>
      
        <div className="col-sm-12 col-md-6 col-xl-3 p-3 d-flex">
          <div className="shadow bg-white rounded p-3 w-100">
            <p className="sub-heading">ENTERPRISE</p>
            <h3>﹩499/month</h3>
            <div className="features">
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Cookie-less analytics
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Advanced Marketing performance with UTM parameters
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Unlimited dashboard user
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Up to 15,000 monthly unique visitors
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Persona prediction with offers
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                SEO
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Speed
              </p>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-xl-3 p-3 d-flex">
        <div className="shadow bg-white rounded p-3 w-100">
            <p className="sub-heading">ENTERPRISE PLUS</p>
            <h3>Get a Quote</h3>
            <div className="features">
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Cookie-less analytics
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Advanced Marketing performance with UTM parameters
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Unlimited dashboard user
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Persona prediction with offers
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                SEO
              </p>
              <p>
                <span>
                  <img src={tick} className="tickImg" alt="tick" />
                </span>{" "}
                Speed
              </p>
              <p>
                <center className="pt-2">
                <StartTrialBtn title="Contact Us" href="/contact-us"/>


                </center>
              </p>
            </div>
          </div>
        </div>
        

      </div>
      

      <div className="my-5 text-center">
                <StartTrialBtn title="Start Free Trial" href="/contact-us"/>
            </div>
    </div>
  );
};
